import React from "react";
import { useTranslation } from "react-i18next";
import { characteristics } from "../../constants";
import "./traitKey.scss";

function TraitKey() {
  const { t } = useTranslation("common");
  const constans = {
    header: t("journey.characterisitcs_legend"),
  };
  const traitsKey = Object.entries(characteristics).map(([key, trait]) => (
    <li className="traits-key__element" key={trait.icon}>
      <i
        className={`icon-trait icon-trait--small icon-trait--${trait.icon}`}
      ></i>
      <span className=" rings-view__gotham traits-key__element-text">
        {t(trait.title)}
      </span>
    </li>
  ));

  return (
    <>
      <div className="traits-key">
        <div>
          <p className="rings-view__characteristics-heading rings-view__characteristics-heading--traitsKey  rings-view__gotham">
            {constans.header}
          </p>
        </div>
        <ul className="traits-key__grid">{traitsKey}</ul>
      </div>
    </>
  );
}

export default TraitKey;
